export default __webpack_public_path__ + "static/media/banner.d5753631.png";